import React, { useState, useEffect } from 'react';

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [daysSinceStart, setDaysSinceStart] = useState(0);
  const [visitorCount, setVisitorCount] = useState(0);

  // 반응형 이미지 설정 - 데스크톱과 모바일 버전 분리
  const heroImages = {
    desktop: [
      '/main_1.jpg',
      '/main_2.jpg',
      '/main_3.jpg',
      '/main_4.jpg',
      '/main_5.jpg',
      '/main_6.jpg'
    ],
    mobile: [
      '/main_1_mobile.jpg',
      '/main_2_mobile.jpg',
      '/main_3_mobile.jpg'
    ]
  };

  // 데스크톱과 모바일 각각의 이미지 수에 맞춰 슬라이드 관리
  const [isMobile, setIsMobile] = useState(false);

  // 모바일 메뉴 상태
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // 스크롤 투 탑 버튼 상태
  const [showScrollTop, setShowScrollTop] = useState(false);

  // 헤더 배경 상태 (스크롤 위치에 따라 변경)
  const [headerBg, setHeaderBg] = useState(false);

  // 떼루아통신 섹션 임시 숨김
  const showNewsletterSection = false;

  // 화면 크기 감지
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // 현재 화면에 따른 이미지 배열
  const currentImages = isMobile ? heroImages.mobile : heroImages.desktop;

  // 슬라이드 자동 변경
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % currentImages.length);
    }, 5000); // 5초마다 슬라이드 변경

    return () => clearInterval(interval);
  }, [currentImages.length]);

  // 화면 크기 변경 시 슬라이드 인덱스 초기화
  useEffect(() => {
    setCurrentSlide(0);
  }, [isMobile]);

  // 모바일 메뉴 열렸을 때 스크롤 방지
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // 컴포넌트 언마운트 시 정리
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  // 스크롤 위치 감지
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setShowScrollTop(scrollTop > 300); // 300px 이상 스크롤 시 버튼 표시
      setHeaderBg(scrollTop > 50); // 50px 이상 스크롤 시 헤더 배경 표시
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 맨 위로 스크롤 함수
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const calculateDays = () => {
      const startDate = new Date('2018-05-08');
      const today = new Date();
      const timeDiff = today.getTime() - startDate.getTime();
      const days = Math.floor(timeDiff / (1000 * 3600 * 24));
      setDaysSinceStart(days);
    };

    calculateDays();
    // 매일 자정에 업데이트
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    const msUntilMidnight = tomorrow.getTime() - now.getTime();

    const midnightTimeout = setTimeout(() => {
      calculateDays();
      // 이후 매일 자정마다 업데이트
      const dailyInterval = setInterval(calculateDays, 24 * 60 * 60 * 1000);
      return () => clearInterval(dailyInterval);
    }, msUntilMidnight);

    return () => clearTimeout(midnightTimeout);
  }, []);

  // 방문자 카운터
  useEffect(() => {
    const updateVisitorCount = () => {
      // 로컬 스토리지에서 기존 방문자 수 가져오기
      const existingCount = localStorage.getItem('fromjeju-visitor-count');
      const existingDate = localStorage.getItem('fromjeju-last-visit');
      const today = new Date().toDateString();

      let newCount = existingCount ? parseInt(existingCount) : 0;

      // 오늘 첫 방문인지 확인 (하루에 한 번만 카운트)
      if (existingDate !== today) {
        newCount += 1;
        localStorage.setItem('fromjeju-visitor-count', newCount.toString());
        localStorage.setItem('fromjeju-last-visit', today);
      }

      setVisitorCount(newCount);
    };

    updateVisitorCount();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        headerBg
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex items-center justify-end">
            <nav className="hidden md:flex space-x-8 lg:space-x-12">
              <a href="#home" className={`${headerBg ? 'text-gray-800 hover:text-jeju-brown' : 'text-white hover:text-white/80'} transition-colors text-sm tracking-wide`}>홈</a>
              <a href="#about" className={`${headerBg ? 'text-gray-800 hover:text-jeju-brown' : 'text-white hover:text-white/80'} transition-colors text-sm tracking-wide`}>About</a>
              <a href="#project" className={`${headerBg ? 'text-gray-800 hover:text-jeju-brown' : 'text-white hover:text-white/80'} transition-colors text-sm tracking-wide`}>프로젝트</a>
              {showNewsletterSection && (
                <a href="#newsletter" className={`${headerBg ? 'text-gray-800 hover:text-jeju-brown' : 'text-white hover:text-white/80'} transition-colors text-sm tracking-wide`}>떼루아통신</a>
              )}
              <a href="#news" className={`${headerBg ? 'text-gray-800 hover:text-jeju-brown' : 'text-white hover:text-white/80'} transition-colors text-sm tracking-wide`}>뉴스</a>
            </nav>
            {/* Mobile menu button */}
            <button
              className={`md:hidden p-2 z-50 relative transition-colors ${
                headerBg ? 'text-gray-800' : 'text-white'
              }`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
              </div>
            </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 md:hidden" onClick={() => setIsMobileMenuOpen(false)} />
      )}

      {/* Mobile Menu */}
      <div className={`fixed top-0 right-0 h-full w-80 bg-white z-50 transform transition-transform duration-300 ease-in-out md:hidden ${
        isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        <div className="p-6 pt-20">
          <nav className="space-y-6">
            <a
              href="#home"
              className="block text-gray-800 hover:text-jeju-brown transition-colors text-lg font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              홈
            </a>
            <a
              href="#about"
              className="block text-gray-800 hover:text-jeju-brown transition-colors text-lg font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </a>
            <a
              href="#project"
              className="block text-gray-800 hover:text-jeju-brown transition-colors text-lg font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              프로젝트
            </a>
            <a
              href="#newsletter"
              className="block text-gray-800 hover:text-jeju-brown transition-colors text-lg font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              떼루아통신
            </a>
            <a
              href="#news"
              className="block text-gray-800 hover:text-jeju-brown transition-colors text-lg font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              뉴스
            </a>
          </nav>

          {/* Store Links */}
          <div className="mt-12 space-y-4">
            <a
              href="https://mkt.shopping.naver.com/link/68347c39fd7d167e0feb6921"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center border-2 border-jeju-brown text-jeju-brown px-6 py-3 hover:bg-jeju-brown hover:text-white transition-all duration-300 font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              제주로부터 스토어
            </a>
            <a
              href="https://mkt.shopping.naver.com/link/683d10006e038273ac2d6f1f"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center bg-jeju-brown text-white px-6 py-3 hover:bg-jeju-brown-dark transition-all duration-300 font-medium"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              남해로부터 스토어
            </a>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section id="home" className="relative h-screen flex items-center overflow-hidden">
        {/* Background Images - 반응형 */}
        {currentImages.map((image, index) => (
          <div key={index}>
            {/* 데스크톱 이미지 */}
            <div
              className={`absolute inset-0 transition-opacity duration-1000 hidden md:block ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
              style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${heroImages.desktop[index]})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed'
              }}
            />
            {/* 모바일 이미지 */}
            <div
              className={`absolute inset-0 transition-opacity duration-1000 block md:hidden ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
              style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${heroImages.mobile[index]})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
          </div>
        ))}

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-10">
          {currentImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === currentSlide
                  ? 'bg-white'
                  : 'bg-white/50 hover:bg-white/75'
              }`}
            />
          ))}
        </div>
        {/* Content */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-4xl">

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-light text-white mb-6 sm:mb-8" style={{lineHeight: '1.2'}}>
              <span className="block">진심있는 제철의 맛</span>
              <span className="block">농촌의 목소리를 전합니다</span>
            </h1>
            <p className="text-white/80 text-base sm:text-lg mb-6 sm:mb-8 font-light leading-relaxed max-w-2xl">
              <span className="block sm:inline">농업은 멀리 있는 것이 아니라</span>
              <br className="hidden sm:block" />
              <span className="block sm:inline">우리가 매일 먹고 마시는 삼시세끼 속에 있습니다</span>
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href="https://mkt.shopping.naver.com/link/68347c39fd7d167e0feb6921"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-white text-white px-6 sm:px-8 py-3 hover:bg-white hover:text-gray-900 transition-all duration-300 font-medium tracking-wide text-center w-full sm:w-auto"
              >
                제주로부터 스토어
          </a>
          <a
                href="https://mkt.shopping.naver.com/link/683d10006e038273ac2d6f1f"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-jeju-brown text-white px-6 sm:px-8 py-3 hover:bg-jeju-brown-dark transition-all duration-300 font-medium tracking-wide text-center w-full sm:w-auto"
              >
                남해로부터 스토어
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="pt-32 pb-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <div className="mb-8">
                <div className="text-sm text-jeju-brown mb-4 tracking-wide">ABOUT</div>
                <h2 className="text-4xl md:text-5xl font-light text-gray-800 mb-8 leading-tight">
                  제주로부터, 남해로부터
                </h2>
              </div>
            </div>
            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p>
                <span className="block sm:inline">우리는 <strong className="text-lg sm:text-xl">농업을 사람들의 곁으로 데려오는 일</strong>을 합니다.</span>
                <br className="hidden sm:block" />
                <span className="block sm:inline">7년 동안 120팀이 넘는 제주/남해 생산자들과 함께하며, 제철의 맛을 도시의 식탁에 전해왔습니다.</span> <span className="block sm:inline">단순히 신선한 농산물을 판매하는 것이 아니라 그 뒤에 있는 사람과 계절, 땅의 이야기를 함께 전하고자 합니다.</span>
              </p>
              <p>
                <span className="block sm:inline">우리가 가장 중요하게 여기는 세 가지 기준 :</span>
                <br className="hidden sm:block" />
                <span className="block sm:inline"><strong className="text-lg sm:text-xl">제철성(제철의 맛)</strong>, <strong className="text-lg sm:text-xl">사람(생산자의 철학과 태도)</strong>, 그리고 <strong className="text-lg sm:text-xl">쓰임과 연결 가능성</strong>입니다.</span> <span className="block sm:inline">자연의 리듬에 따라 제주의 밭과 바다가 내어주는 그 계절의 깊은맛을 전합니다.</span>
              </p>
              <p>
                <span className="block sm:inline">때로는 농부의 밭에서, 때로는 요리사의 공간에서 직접 제주의 맛과 이야기를 나누며 <strong className="text-lg sm:text-xl">밥상이 곧 농업의 끝이자 관계의 시작</strong>임을 전하고 있습니다.</span> <span className="block sm:inline">제주로부터&남해로부터는 오늘도, 밭과 바다에서 시작된 농촌의 진심을 도시의 식탁으로 옮기는 중입니다.</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <div className="text-sm text-jeju-brown mb-4 tracking-wide">우리의 성과</div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-gray-800 mb-6 sm:mb-8 px-4">
              사람과 먹거리를 잇는 힘
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12 sm:mb-16">
            <div className="text-center p-4">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-light text-jeju-brown mb-3 sm:mb-4">120팀+</div>
              <div className="text-gray-600">
                <div className="font-medium text-sm sm:text-base">제주 생산자</div>
                <div className="text-xs sm:text-sm">60년 최고령부터 청년농부까지</div>
              </div>
            </div>

            <div className="text-center p-4">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-light text-jeju-brown mb-3 sm:mb-4">250종+</div>
              <div className="text-gray-600">
                <div className="font-medium text-sm sm:text-base">제철 식재료</div>
                <div className="text-xs sm:text-sm">밭과 바다의 계절 산물</div>
              </div>
            </div>

            <div className="text-center p-4">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-light text-jeju-brown mb-3 sm:mb-4">{daysSinceStart.toLocaleString()}일</div>
              <div className="text-gray-600">
                <div className="font-medium text-sm sm:text-base">함께한 시간</div>
                <div className="text-xs sm:text-sm">2018년 5월 8일부터</div>
              </div>
            </div>

            <div className="text-center p-4">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-light text-jeju-brown mb-3 sm:mb-4">13만장+</div>
              <div className="text-gray-600">
                <div className="font-medium text-sm sm:text-base">기록된 순간</div>
                <div className="text-xs sm:text-sm">농부와 계절의 이야기</div>
              </div>
            </div>
          </div>

          {/* 계절별 대표 식재료 */}
          <div className="bg-white rounded-lg p-6 sm:p-8 shadow-sm mb-6 sm:mb-8">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 sm:mb-6 text-center">제주의 사계절</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 text-center">
              <div className="p-3">
                <div className="text-xl sm:text-2xl mb-2 text-gray-600">◐</div>
                <div className="font-medium text-gray-800 mb-2 text-sm sm:text-base">봄</div>
                <div className="text-xs sm:text-sm text-gray-600">고사리, 아스파라거스, 블루베리</div>
              </div>
              <div className="p-3">
                <div className="text-xl sm:text-2xl mb-2 text-gray-600">○</div>
                <div className="font-medium text-gray-800 mb-2 text-sm sm:text-base">여름</div>
                <div className="text-xs sm:text-sm text-gray-600">초당옥수수, 풋귤, 애플망고</div>
              </div>
              <div className="p-3">
                <div className="text-xl sm:text-2xl mb-2 text-gray-600">◑</div>
                <div className="font-medium text-gray-800 mb-2 text-sm sm:text-base">가을</div>
                <div className="text-xs sm:text-sm text-gray-600">옥돔, 갈치, 에어룸토마토</div>
              </div>
              <div className="p-3">
                <div className="text-xl sm:text-2xl mb-2 text-gray-600">●</div>
                <div className="font-medium text-gray-800 mb-2 text-sm sm:text-base">겨울</div>
                <div className="text-xs sm:text-sm text-gray-600">감귤, 레몬, 대방어</div>
              </div>
            </div>
          </div>


        </div>
      </section>

      {/* Local to Table Section */}
      <section id="project" className="pt-32 pb-16 sm:pb-20 lg:pb-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <div className="text-sm text-jeju-brown mb-4 tracking-wide">OFFLINE PROJECT</div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-gray-800 mb-6 sm:mb-8 px-4">
              Local to Table
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
              <span className="block sm:inline">소비자와 생산자가</span> <span className="block sm:inline">직접 경험하고 나눌 수 있는 자리</span>
              <br className="hidden sm:block" />
              <span className="block sm:inline">식재료의 쓰임이 끝나는 곳이 아닌</span>
              <br className="hidden sm:block" />
              <span className="block sm:inline">새로운 관계가 시작되는 식탁</span>
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12">
            {/* 제로킬로미터 테이블 */}
            <div className="bg-gray-50 rounded-lg p-6 sm:p-8">
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">제로킬로미터 테이블</h3>

              {/* 이미지 갤러리 - 반응형 최적화 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6">
                <picture>
                  <source
                    media="(min-width: 768px)"
                    srcSet="/zero_1_desktop.jpg"
                  />
                  <img
                    src="/zero_1_mobile.jpg"
                    alt="제로킬로미터 테이블 현장 1"
                    className="w-full h-40 sm:h-48 object-cover rounded-lg"
                  />
                </picture>
                <picture>
                  <source
                    media="(min-width: 768px)"
                    srcSet="/zero_2_desktop.jpg"
                  />
                  <img
                    src="/zero_2_mobile.jpg"
                    alt="제로킬로미터 테이블 현장 2"
                    className="w-full h-40 sm:h-48 object-cover rounded-lg"
                  />
                </picture>
              </div>

              <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-6">
                농부의 밭에서 그날 수확한 작물로 요리를 만들고, 소비자들이 생산자와 함께 밥상을 나누는 특별한 경험.
                흙 내음 가득한 밭에서 먹는 밥상은, 식사를 넘어 농업과 농촌을 오감으로 체험하는 자리가 됩니다.
              </p>
              <div className="flex items-center text-jeju-brown text-xs sm:text-sm font-medium">
                <span>밭에서 바로 만나는 진짜 Farm to Table</span>
              </div>
            </div>

            {/* 셰프의 테이블 */}
            <div className="bg-gray-50 rounded-lg p-6 sm:p-8">
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">셰프의 테이블</h3>

              {/* 이미지 갤러리 - 반응형 최적화 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6">
                <picture>
                  <source
                    media="(min-width: 768px)"
                    srcSet="/d_1_desktop.jpg"
                  />
                  <img
                    src="/d_1_mobile.jpg"
                    alt="셰프의 테이블 현장 1"
                    className="w-full h-40 sm:h-48 object-cover rounded-lg"
                  />
                </picture>
                <picture>
                  <source
                    media="(min-width: 768px)"
                    srcSet="/d_2_desktop.jpg"
                  />
                  <img
                    src="/d_2_mobile.jpg"
                    alt="셰프의 테이블 현장 2"
                    className="w-full h-40 sm:h-48 object-cover rounded-lg"
                  />
                </picture>
              </div>

              <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-6">
                <span className="block sm:inline">제주산 제철 식재료를 요리사의 해석으로 재구성하여</span> <span className="block sm:inline">도시의 식탁에서 '제주의 지금'을 경험할 수 있는 방식.</span>
                <br className="hidden sm:block" />
                <span className="block sm:inline">제주로부터&남해로부터는 식재료를 큐레이션하고,</span> <span className="block sm:inline">그 이야기를 함께 전하며,</span> <span className="block sm:inline">때로는 농부님을 직접 모시기도 합니다.</span>
              </p>
              <div className="flex items-center text-jeju-brown text-xs sm:text-sm font-medium">
                <span>요리사와 함께하는 제주의 계절 이야기</span>
              </div>
            </div>
              </div>

          <div className="text-center mt-8 sm:mt-12">
            <div className="bg-jeju-brown-light/10 rounded-lg p-4 sm:p-6 max-w-4xl mx-auto">
              <blockquote className="text-base sm:text-lg text-gray-700 italic">
                "<span className="block sm:inline">한 끼의 식사를 통해</span> <span className="block sm:inline">땅과 사람, 계절과 이야기를</span> <span className="block sm:inline">잇는 프로젝트</span>"
              </blockquote>
            </div>
          </div>
        </div>
      </section>

                {/* 떼루아통신 Section */}
      {showNewsletterSection && (
      <section id="newsletter" className="pt-32 pb-16 sm:pb-20 lg:pb-24 bg-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <div className="text-sm text-jeju-brown mb-4 tracking-wide">SUBSCRIPTION SERVICE</div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-gray-800 mb-6 sm:mb-8 px-4">
              떼루아통신
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
              <span className="block sm:inline">'읽고, 먹고, 만나는'</span> <span className="block sm:inline">구독형 서비스</span><br className="hidden sm:block" />
              <span className="block sm:inline">월간 정보지 + 부록 식재료로</span> <span className="block sm:inline">새로운 식문화를 경험하세요</span>
            </p>
            <div className="mt-4">
              <span className="inline-block bg-jeju-brown text-white px-4 py-2 text-sm font-medium tracking-wide">
                2026년 오픈예정
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
            {/* 제철 식재료 */}
            <div className="bg-white rounded-lg p-6 sm:p-8 text-center shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-jeju-brown-light/20 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <span className="text-2xl sm:text-3xl">🥬</span>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-3 sm:mb-4">제철 식재료</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                제주와 남해에서 직접 선별한 제철 농수축산물을<br />
                매월 큐레이션하여 전달합니다
              </p>
            </div>

            {/* 생산자 이야기 */}
            <div className="bg-white rounded-lg p-6 sm:p-8 text-center shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-jeju-brown-light/20 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <span className="text-2xl sm:text-3xl">👨‍🌾</span>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-3 sm:mb-4">생산자 이야기</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                7년간 쌓아온 생산자와의 관계를 바탕으로<br />
                진정성 있는 이야기를 전합니다
              </p>
            </div>

            {/* 식문화 콘텐츠 */}
            <div className="bg-white rounded-lg p-6 sm:p-8 text-center shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-jeju-brown-light/20 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <span className="text-2xl sm:text-3xl">📖</span>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-3 sm:mb-4">식문화 콘텐츠</h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                로컬의 식문화 콘텐츠와 레시피를 전하고<br />
                생산자와 소비자가 만나는 경험을 제공합니다
              </p>
            </div>
          </div>

          {/* 구독 플랜 */}
          <div className="bg-white rounded-lg p-8 shadow-sm">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-semibold text-gray-800 mb-4">구독 플랜</h3>
              <p className="text-gray-600">2026년 Pre-launch 예정</p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="border border-gray-200 rounded-lg p-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-4">일반 회원</h4>
                <div className="text-3xl font-light text-jeju-brown mb-4">월 35,000원</div>
                <ul className="space-y-2 text-sm text-gray-600 mb-6">
                  <li>• 월간 떼루아통신 정보지</li>
                  <li>• 제철 식재료 1-2종</li>
                  <li>• 온라인 커뮤니티 참여</li>
                </ul>

              </div>

              <div className="border-2 border-jeju-brown rounded-lg p-6 relative">
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-jeju-brown text-white px-4 py-1 rounded-full text-sm">
                  추천
                </div>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">프리미엄 회원</h4>
                <div className="text-3xl font-light text-jeju-brown mb-4">월 50,000원</div>
                <ul className="space-y-2 text-sm text-gray-600 mb-6">
                  <li>• 월간 떼루아통신 정보지</li>
                  <li>• 특별 테마 식재료 3-4종</li>
                  <li>• Farm to Table 체험 우선 예약</li>
                  <li>• 생산자와의 직접 만남 기회</li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </section>
      )}

      {/* Instagram Feed Section */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <div className="text-sm text-jeju-brown mb-4 tracking-wide">INSTAGRAM</div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {/* Instagram Post 1 */}
            <div className="bg-white shadow-sm hover:shadow-md transition-shadow overflow-hidden">
              <a
                href="https://www.instagram.com/p/DIZMojYy171/?igsh=MTFiaDcydXJmb3Uxdg=="
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <div className="aspect-square relative overflow-hidden bg-gradient-to-br from-amber-100 to-orange-200">
                  <picture>
                    <source
                      media="(min-width: 768px)"
                      srcSet="/daesan_desktop.jpg"
                    />
                    <img
                      src="/daesan_mobile.jpg"
                      alt="대산농업연수 프랑스 여행 단체사진"
                      className="w-full h-full object-cover"
                    />
                  </picture>
                  <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors"></div>
                </div>
                <div className="p-4 sm:p-6">
                  <p className="text-xs sm:text-sm text-gray-500 mb-2 sm:mb-3">#대산농업연수 #프랑스 #15일차 #파리로가는버스안</p>
                  <p className="text-sm sm:text-base text-gray-800 leading-relaxed mb-2 sm:mb-3">
                    유럽 연수의 정규 일정이 모두 마무리되었다.
                  </p>
                  <div className="flex justify-end">
                    <span className="text-jeju-brown text-xs sm:text-sm">더보기 →</span>
                  </div>
                </div>
              </a>
            </div>

            {/* Instagram Post 2 */}
            <div className="bg-white shadow-sm hover:shadow-md transition-shadow overflow-hidden">
              <a
                href="https://www.instagram.com/p/DA-Bj_xSDEL/?igsh=MTJmcDl3ODBxaTdxZw=="
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <div className="aspect-square relative overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
                  <picture>
                    <source
                      media="(min-width: 768px)"
                      srcSet="/DSC03052_desktop.jpg"
                    />
                    <img
                      src="/DSC03052_mobile.jpg"
                      alt="농부사진전 진정은사진전"
                      className="w-full h-full object-cover"
                    />
                  </picture>
                  <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors"></div>
                </div>
                <div className="p-4 sm:p-6">
                  <p className="text-xs sm:text-sm text-gray-500 mb-2 sm:mb-3">#농부사진전 #진정은사진전 #별을노래하는사람들을위하여</p>
                  <p className="text-sm sm:text-base text-gray-800 leading-relaxed mb-2 sm:mb-3">
                    나의 첫 사진전, 잊지못할 무대였습니다 ❤️
                  </p>
                  <div className="flex justify-end">
                    <span className="text-jeju-brown text-xs sm:text-sm">더보기 →</span>
                  </div>
                </div>
              </a>
            </div>

            {/* Instagram Post 3 */}
            <div className="bg-white shadow-sm hover:shadow-md transition-shadow overflow-hidden">
              <a
                href="https://www.instagram.com/p/C0E3nvXyCI1/?igsh=MWYzMzR4ZDVtcW81aA=="
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <div
                  className="aspect-square relative overflow-hidden bg-gradient-to-br from-orange-100 to-orange-200"
                  style={{
                    backgroundImage: 'url(/tan.JPG)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                >
                  <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors"></div>
                </div>
                <div className="p-4 sm:p-6">
                  <p className="text-xs sm:text-sm text-gray-500 mb-2 sm:mb-3">#제주입말음식연구회 #제주귤음식 #시트러스팝업</p>
                  <p className="text-sm sm:text-base text-gray-800 leading-relaxed mb-2 sm:mb-3">
                    온통 귤로 가득했던 지난 며칠간의 여정⁣
                  </p>
                  <div className="flex justify-end">
                    <span className="text-jeju-brown text-xs sm:text-sm">더보기 →</span>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href="https://www.instagram.com/from.jeju__"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-jeju-brown text-white px-8 py-3 rounded-full font-medium hover:bg-jeju-brown-dark transition-colors"
            >
              <span>📷</span>
              <span>인스타그램에서 더보기</span>
            </a>
          </div>
        </div>
      </section>

      {/* YouTube Section */}
      <section id="youtube" className="pt-32 pb-16 sm:pb-20 lg:pb-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <div className="text-sm text-jeju-brown mb-4 tracking-wide">YOUTUBE</div>
          </div>

          <div className="grid gap-8 xl:grid-cols-3 lg:grid-cols-2">
            <div className="bg-gray-100 rounded-3xl overflow-hidden shadow-sm border border-gray-200">
              <div className="relative pb-[56.25%] overflow-hidden">
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src="https://www.youtube.com/embed/a3ykGFAQ8qA?rel=0&modestbranding=1"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
              <div className="border-t border-gray-200 p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">제 1회 대산농촌포럼 발표</h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  농으로부터 : 농과 식, 농촌과 도시를 연결하다
                </p>
              </div>
            </div>

            <div className="bg-gray-100 rounded-3xl overflow-hidden shadow-sm border border-gray-200">
              <div className="relative pb-[56.25%] overflow-hidden">
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src="https://www.youtube.com/embed/7jQwL-nDEmo?start=10&rel=0&modestbranding=1"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
              <div className="border-t border-gray-200 p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">2025 소상공인대상 최우수상 | 오마이뉴스</h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  농장에서 식탁까지 플랫폼 제주로부터
                </p>
              </div>
            </div>

            <div className="bg-gray-100 rounded-3xl overflow-hidden shadow-sm border border-gray-200">
              <div className="relative pb-[56.25%] overflow-hidden">
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src="https://www.youtube.com/embed/6NJ5YD7Bn2o?start=181&rel=0&modestbranding=1"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
              <div className="border-t border-gray-200 p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">나는 제주로 출근한다</h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  세화마을에서 워케이션 이야기
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 미디어 소개 Section */}
      <section id="news" className="pt-32 pb-16 sm:pb-20 lg:pb-24 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 sm:mb-16">
            <div className="text-sm text-jeju-brown mb-4 tracking-wide">MEDIA</div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-gray-800 mb-6 sm:mb-8 px-4">
              미디어 소개
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
              <span className="block sm:inline">제주로부터&남해로부터의 이야기를</span> <span className="block sm:inline">전하는 언론 보도</span>
            </p>
          </div>

          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {/* 기사 1 - 더가게 (최신) */}
            <a
              href="https://thegage.co.kr/story/1308"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start bg-white rounded-lg p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base lg:text-lg truncate">
                  [우리동네 크라우드펀딩] 계절이 빚는 제주의 맛, 도시의 식탁으로 전하는 '제주로부터'
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm mb-2 sm:mb-3 leading-relaxed line-clamp-2">
                  매일 우리집 식탁 위에 올라오는 다양한 농산물. 여러분은 이 식재료가 어디에서 왔는지, 어떤 이야기가 담겨 있는지 생각해 보신 적 있으신가요?
                </p>
                <div className="flex items-center space-x-4 text-xs text-gray-400">
                  <span>더가게</span>
                  <span>2025.07.29</span>
                  </div>
                  </div>
              <div className="w-20 h-12 sm:w-24 sm:h-16 rounded ml-4 sm:ml-6 flex-shrink-0 overflow-hidden bg-gray-100 flex items-center justify-center">
                <div className="text-xs font-bold text-gray-600">더가게</div>
                  </div>
            </a>

            {/* 기사 2 - 대산농촌재단 */}
            <a
              href="https://webzine.dsa.or.kr/?p=14307"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start bg-white rounded-lg p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base lg:text-lg truncate">
                  [대산농업연수생 인터뷰] 제주로부터 진정은 대표 "농업을 멋지게 만들고 싶습니다"
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm mb-2 sm:mb-3 leading-relaxed line-clamp-2">
                  "농업은 멀리 있는 것이 아니라, 우리가 매일 먹고 마시는 모든 것 삼시세끼 속에 있다는 사실을요." 제주로부터는 농업을 사람들의 곁으로 데려오는 일을 합니다.
                </p>
                <div className="flex items-center space-x-4 text-xs text-gray-400">
                  <span>대산농촌재단</span>
                  <span>2024</span>
                </div>

              </div>
              <div className="w-20 h-12 sm:w-24 sm:h-16 rounded ml-4 sm:ml-6 flex-shrink-0 overflow-hidden bg-blue-50 flex items-center justify-center">
                <div className="text-xs font-bold text-blue-600">대산농촌재단</div>
              </div>
            </a>

            {/* 기사 3 - J커넥트 */}
            <a
              href="https://jconnect.oopy.io/231804f8-92cb-813d-a8aa-d4831e803aac"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start bg-white rounded-lg p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base lg:text-lg truncate">
                  제주로부터 만들어진 가치를 온전히 전하다
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm mb-2 sm:mb-3 leading-relaxed line-clamp-2">
                  제주의 농수축산물을 전국으로 전하며 로컬의 가치를 알리는 '제주로부터'. 단순한 상품 판매를 넘어 생산자와 소비자가 함께 만드는 가치 있는 이야기를 전합니다.
                </p>
                <div className="flex items-center space-x-4 text-xs text-gray-400">
                  <span>J커넥트</span>
                  <span>2024</span>
                </div>

              </div>
              <div className="w-20 h-12 sm:w-24 sm:h-16 rounded ml-4 sm:ml-6 flex-shrink-0 overflow-hidden bg-green-50 flex items-center justify-center">
                <div className="text-xs font-bold text-green-600">J커넥트</div>
              </div>
            </a>

            {/* 기사 4 - 한라일보 */}
            <a
              href="https://m.ihalla.com/article.php?aid=1728193769763445036&page=1"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start bg-white rounded-lg p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base lg:text-lg truncate">
                  제주 농부의 삶 카메라에 담은 7년의 기록 첫선
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm mb-2 sm:mb-3 leading-relaxed line-clamp-2">
                  진정은 작가가 7년간 제주 농부들의 삶을 카메라에 담아온 사진전을 개최합니다. 약 10만 장의 사진 중 30점을 선별하여 제주시 화북동 레미콘 갤러리에서 전시합니다.
                </p>
                <div className="flex items-center space-x-4 text-xs text-gray-400">
                  <span>한라일보</span>
                  <span>2024</span>
                </div>

              </div>
              <div className="w-20 h-12 sm:w-24 sm:h-16 rounded ml-4 sm:ml-6 flex-shrink-0 overflow-hidden bg-orange-50 flex items-center justify-center">
                <div className="text-xs font-bold text-orange-600">한라일보</div>
              </div>
            </a>

            {/* 기사 5 - 플래텀 */}
            <a
              href="https://platum.kr/archives/251828"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start bg-white rounded-lg p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base lg:text-lg truncate">
                  [스타트업 인터뷰] 제주로부터 "농업을 멋지게 만드는 것이 목표"
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm mb-2 sm:mb-3 leading-relaxed line-clamp-2">
                  제주 지역 농산물 유통 플랫폼 '제주로부터'가 주목받고 있다. IT 출신 창업자가 농업 분야에 뛰어들어 만든 이 플랫폼은 생산자와 소비자를 직접 연결한다.
                </p>
                <div className="flex items-center space-x-4 text-xs text-gray-400">
                  <span>플래텀</span>
                  <span>2024</span>
                </div>

              </div>
                            <div className="w-20 h-12 sm:w-24 sm:h-16 rounded ml-4 sm:ml-6 flex-shrink-0 overflow-hidden bg-purple-50 flex items-center justify-center">
                <div className="text-xs font-bold text-purple-600">플래텀</div>
            </div>
            </a>
          </div>
        </div>
      </section>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-50 w-12 h-12 bg-jeju-brown text-white rounded-full shadow-lg hover:bg-jeju-brown-dark transition-all duration-300 flex items-center justify-center md:hidden"
          aria-label="맨 위로 가기"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </button>
      )}

      {/* Footer */}
      <footer className="bg-white border-t border-gray-100 py-12 sm:py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* 첫 번째 라인: 제주로부터&남해로부터 */}
          <div className="mb-8 sm:mb-12">
            <div className="text-xl sm:text-2xl font-bold text-gray-800 mb-3 sm:mb-4">제주로부터&남해로부터</div>
            <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
              <span className="block sm:inline">계절이 가장 먼저 도착하는 섬에서 농부의 마음과 바다의 선물을 담아 도시의 식탁으로 전하는 이야기</span>
            </p>
          </div>

          {/* 두 번째 라인: 소셜과 고객센터 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-12 mb-8 sm:mb-12">
            <div>
              <h4 className="font-semibold text-gray-800 mb-3 sm:mb-4 text-sm sm:text-base">소셜</h4>
              <div className="flex space-x-3 sm:space-x-4">
                <a href="https://www.instagram.com/from.jeju__" target="_blank" rel="noopener noreferrer" title="인스타그램" className="w-10 h-10 bg-jeju-brown-light/20 rounded-full flex items-center justify-center hover:bg-jeju-brown-light/40 transition-colors">
                  <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="m16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
                <a href="https://blog.naver.com/fromjejudo" target="_blank" rel="noopener noreferrer" title="네이버 블로그" className="w-10 h-10 bg-jeju-brown-light/20 rounded-full flex items-center justify-center hover:bg-jeju-brown-light/40 transition-colors">
                  <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                  </svg>
                </a>
                <a href="https://brunch.co.kr/@fromjeju" target="_blank" rel="noopener noreferrer" title="브런치" className="w-10 h-10 bg-jeju-brown-light/20 rounded-full flex items-center justify-center hover:bg-jeju-brown-light/40 transition-colors">
                  <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                    <polyline points="14,2 14,8 20,8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10,9 9,9 8,9"></polyline>
                  </svg>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-gray-800 mb-3 sm:mb-4 text-sm sm:text-base">고객센터</h4>
              <div className="space-y-3">
                <a href="https://talk.naver.com/ct/wchaxl" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 hover:text-jeju-brown transition-colors group">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 bg-jeju-brown-light/20 rounded-full flex items-center justify-center group-hover:bg-jeju-brown-light/40 transition-colors">
                    <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
                    </svg>
                  </div>
                  <span className="text-sm sm:text-base text-gray-700 group-hover:text-jeju-brown">네이버 톡톡 상담</span>
                </a>
                <a href="mailto:fromjejudo@naver.com" className="flex items-center space-x-3 hover:text-jeju-brown transition-colors group">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 bg-jeju-brown-light/20 rounded-full flex items-center justify-center group-hover:bg-jeju-brown-light/40 transition-colors">
                    <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                  <span className="text-sm sm:text-base text-gray-700 group-hover:text-jeju-brown">fromjejudo@naver.com</span>
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-6 sm:pt-8 text-center">
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6">
              <p className="text-gray-500 text-xs sm:text-sm">
                © 2018 제주로부터. All rights reserved.
              </p>
              <div className="flex items-center space-x-2 text-gray-500 text-xs sm:text-sm">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clipRule="evenodd" />
                </svg>
                <span>방문자 수: {visitorCount.toLocaleString()}명</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;
